import { motion } from 'framer-motion';
import { theme } from '@/lib/theme';

interface StatCardProps {
  label: string;
  value: number | string;
  icon: React.ReactNode;
  trend?: {
    value: string;
    positive: boolean;
  };
  accent?: boolean;
  index?: number;
}

export default function StatCard({ label, value, icon, trend, accent = false, index = 0 }: StatCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.08, ease: 'easeOut' }}
      whileHover={{ scale: 1.02, y: -2 }}
      className="rounded-xl p-5 border cursor-default transition-all"
      style={{
        backgroundColor: accent ? 'rgba(255,255,255,0.05)' : theme.colors.bgSurface,
        borderColor: accent ? theme.colors.primary : theme.colors.border,
      }}
    >
      <div className="flex items-start justify-between mb-4">
        <div
          className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0"
          style={{ backgroundColor: 'rgba(255,255,255,0.06)' }}
        >
          {icon}
        </div>
        {trend && (
          <motion.span
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.08 + 0.2 }}
            className={`text-xs font-medium px-2 py-0.5 rounded-full ${
              trend.positive
                ? 'text-emerald-400 bg-emerald-400/10'
                : 'text-red-400 bg-red-400/10'
            }`}
          >
            {trend.positive ? '+' : ''}{trend.value}
          </motion.span>
        )}
      </div>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: index * 0.08 + 0.15 }}
        className="text-3xl font-bold mb-1"
        style={{ color: accent ? theme.colors.primary : theme.colors.textPrimary }}
      >
        {value}
      </motion.p>

      <p
        className="text-xs uppercase tracking-wider font-medium"
        style={{ color: theme.colors.textMuted }}
      >
        {label}
      </p>
    </motion.div>
  );
}
